import { SelectButton, SelectButtonProps } from 'primereact/selectbutton';
import { withFormControl } from '../with-form-control';

export const FormSelectButton = withFormControl<SelectButtonProps>((props) => {
  return <SelectButton {...props} />;
});
